(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    /* ------------------------------------------------------------------
      Collection infinite-scroll / load-more: back-button restore
      ------------------------------------------------------------------
      Problem: products appended by Ajaxinate live only in the DOM. When the
      shopper opens a product and presses Back, the browser re-requests the
      collection (bfcache is blocked by the theme's vendor scripts), only the
      first page renders, and the remembered scroll offset is clamped to the
      bottom of the now-shorter page - landing on the FAQ / footer.

      Fix: when a product card is clicked (or the page is left) we snapshot
      the full grid HTML, the current pagination markup and the scroll
      position into sessionStorage, keyed by the collection URL (incl. any
      filter/sort params). On a back/forward navigation we rebuild the grid
      from that snapshot BEFORE the browser paints the first frame, then
      scroll to the exact card that was clicked.
    ------------------------------------------------------------------ */
    (function () {
      var GRID_SEL = '.AjaxinateLoop';
      var PAGI_SEL = '.AjaxinatePagination';
      var KEY = 'ensCollectionState:' + location.pathname + location.search;
      var MAX_AGE = 30 * 60 * 1000;   // 30 min
      var MAX_HTML = 2.5 * 1024 * 1024; // stay well under sessionStorage quota

      function isBackForward() {
        try {
          var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
          if (nav && nav.type) return nav.type === 'back_forward';
          return performance.navigation && performance.navigation.type === 2;
        } catch (e) { return false; }
      }

      function readState() {
        try {
          var raw = sessionStorage.getItem(KEY);
          if (!raw) return null;
          var st = JSON.parse(raw);
          if (!st || !st.ts || Date.now() - st.ts > MAX_AGE) return null;
          return st;
        } catch (e) { return null; }
      }

      function saveState(clickedHref) {
        var grid = document.querySelector(GRID_SEL);
        if (!grid) return;
        var pagi = document.querySelector(PAGI_SEL);
        var html = grid.innerHTML;
        try {
          var prev = readState() || {};
          sessionStorage.setItem(KEY, JSON.stringify({
            ts: Date.now(),
            html: html.length <= MAX_HTML ? html : null,
            pagi: pagi ? pagi.innerHTML : null,
            scrollY: window.pageYOffset || document.documentElement.scrollTop || 0,
            // keep the clicked product from the click handler if pagehide fires afterwards
            clicked: clickedHref || prev.clicked || null
          }));
        } catch (e) { /* quota / private mode - degrade silently */ }
      }

      function headerOffset() {
        var h = document.querySelector('.site-header');
        if (!h) return 0;
        var pos = getComputedStyle(h).position;
        return (pos === 'fixed' || pos === 'sticky') ? h.getBoundingClientRect().height : 0;
      }

      function scrollToState(st) {
        var target = null;
        if (st.clicked) {
          var links = document.querySelectorAll(GRID_SEL + ' a[href]');
          for (var i = 0; i < links.length; i++) {
            if (links[i].getAttribute('href') === st.clicked || links[i].href === st.clicked) {
              target = links[i].closest('.grid__item') || links[i];
              break;
            }
          }
        }
        if (target) {
          var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
          window.scrollTo(0, Math.max(0, top));
        } else if (typeof st.scrollY === 'number') {
          window.scrollTo(0, st.scrollY);
        }
      }

      function restore() {
        var st = readState();
        if (!st) return false;
        var grid = document.querySelector(GRID_SEL);
        if (!grid || !st.html) return false;

        grid.innerHTML = st.html;
        var pagi = document.querySelector(PAGI_SEL);
        if (pagi && st.pagi !== null) pagi.innerHTML = st.pagi;

        // Re-run card-level initialisers the theme runs after AJAX renders
        ['wishlist', 'compare', 'countdown', 'swatchCard2'].forEach(function (k) {
          try { window.theme && theme[k] && typeof theme[k].load === 'function' && theme[k].load(); } catch (e) {}
        });

        scrollToState(st);
        // Repeat once layout has settled (fonts / lazy images / async sections)
        requestAnimationFrame(function () { scrollToState(st); });
        setTimeout(function () { scrollToState(st); }, 250);
        return true;
      }

      function initAjaxinate() {
        var pagi = document.querySelector(PAGI_SEL);
        if (!pagi || typeof Ajaxinate === 'undefined') return;
        var elem = pagi.getAttribute('data-pagination');
        new Ajaxinate({
          container: GRID_SEL,
          pagination: PAGI_SEL,
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      }

      // --- capture state when leaving --------------------------------------
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest(GRID_SEL + ' a[href*="/products/"]');
        if (!a) return;
        saveState(a.getAttribute('href'));
      }, true);

      window.addEventListener('pagehide', function () {
        if (document.querySelector(GRID_SEL)) saveState(null);
      });

      // --- restore on back/forward -----------------------------------------
      var backNav = isBackForward();
      if (backNav && readState()) {
        // We handle scroll ourselves; stop the browser clamping to the footer.
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      } else {
        // Fresh visit / reload / filter change: start clean.
        try { sessionStorage.removeItem(KEY); } catch (e) {}
      }

      function boot() {
        if (backNav) restore();
        // ajaxinate.min.js is a deferred script that sits after this section's
        // compiled JS in the document, so it may not be defined yet - wait for
        // DOMContentLoaded (all deferred scripts have run by then).
        if (typeof Ajaxinate !== 'undefined') {
          initAjaxinate();
        } else {
          document.addEventListener('DOMContentLoaded', initAjaxinate);
        }
        if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
      } else {
        boot();
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(),
                       window.SPR.initRatingHandler(),
                       window.SPR.initDomEls(),
                       window.SPR.loadProducts(),
                       window.SPR.loadBadges();
              }
            }
          })
          .catch(e => { console.error(e); });
      };
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 500px 0px' }).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();
})();
